import type { Language } from 'apis/LanguagesApi';
import type { Country } from 'apis/CountryApi';
import type { State } from 'apis/StateApi';

export type PartnerCreateEditPermissions = {
	CanCreate: boolean;
	CanEdit: boolean;
	IsAssociation: boolean;
	IsSuperAdmin: boolean;
};

export type PartnerCreateEditContextValue = {
	countries: Country[];
	languages: Language[];
	pageState: PageState;
	partnerId: number;
	partnerType: number;
	permissions: PartnerCreateEditPermissions;
	selectedPartnerName: string;
	setStates: (states: State[]) => void;
	states: State[];
};

export enum PageState {
	Edit = 1,
	Create = 4
}
